/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ContractorJobsList_paymentStatusTypes$ref: FragmentReference;
declare export opaque type ContractorJobsList_paymentStatusTypes$fragmentType: ContractorJobsList_paymentStatusTypes$ref;
export type ContractorJobsList_paymentStatusTypes = {|
  +enumValues: ?$ReadOnlyArray<{|
    +name: string,
    +description: ?string,
  |}>,
  +$refType: ContractorJobsList_paymentStatusTypes$ref,
|};
export type ContractorJobsList_paymentStatusTypes$data = ContractorJobsList_paymentStatusTypes;
export type ContractorJobsList_paymentStatusTypes$key = {
  +$data?: ContractorJobsList_paymentStatusTypes$data,
  +$fragmentRefs: ContractorJobsList_paymentStatusTypes$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ContractorJobsList_paymentStatusTypes",
  "type": "__Type",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '70d67ddf637c31072a7c4fce34932c85';
module.exports = node;
